import { ReactComponent as Login } from 'assets/icons/icon-login.svg';

export default Login;
